<div>
    <div class="ai-cards-header">
        <h2 class="ai-title">{{ 'AI.AI_SEGMENTATION_LIST' | translate }}</h2>
        <h3 class="ai-subtitle">{{ 'AI.SEGMENTATION_LIST.DESCRIPTION' | translate }}</h3>
    </div>
    <div *ngIf="aiUploadBatchObject" class="ai-cards-row w-100">
        <div>
            <lib-card
            [label]="'AI.SEGMENTATION_LIST.BUILDINGS'"
            [value]="aiUploadBatchObject.buildingsCount"
            [showDropdown]="false"
            [showToggle]="false"
            >        
            </lib-card>
        </div>
        <div>
            <lib-card
            [label]="'AI.SEGMENTATION_LIST.LV_POLES'"
            [value]="aiUploadBatchObject.lvPolesCount"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </lib-card>
        </div>
        <div>
            <lib-card
            [label]="'AI.SEGMENTATION_LIST.DISTRIBUTION_TRANSFORMERS'"
            [value]="aiUploadBatchObject.dtGroundMountedCount + aiUploadBatchObject.dtPoleMountedCount"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </lib-card>
        </div>
        <div>
            <lib-card
            [label]="'AI.SEGMENTATION_LIST.MV_POLES'"
            [value]="aiUploadBatchObject.mvPolesCount"
            [showDropdown]="false"
            [showToggle]="false">
            </lib-card>
        </div>
        <div>
            <lib-card
            [label]="'AI.SEGMENTATION_LIST.INJECTION_SUBSTATIONS'"
            [value]="aiUploadBatchObject.injectionSubstations"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </lib-card>
        </div>
        <div>
            <lib-card
            [label]="'AI.SEGMENTATION_LIST.HV_POLES'"
            [value]="aiUploadBatchObject.hvPolesCount"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </lib-card>
        </div>
        <div>
            <lib-card
            [label]="'AI.SEGMENTATION_LIST.TRANSMISSION_STATIONS'"
            [value]="aiUploadBatchObject.tsCount"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </lib-card>
        </div>
    </div>
    <div class="ai-dropdown dropdown">
        <button (click)="toggleDropdown()" class="dropdown-button">
            <span>{{ objectCategoryName | translate }}</span>
            <img src="../../../assets/icons/ng_v3/dropdown-icon.svg" alt="dropdown icon" />
        </button>
        <div *ngIf="dropdownOpened" class="dropdown-options">
            <div class="dropdown-description">{{ 'AI.FILTER_BY_OBJECT_CATEGORY' | translate }}</div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.ALL)" class="dropdown-option">
                <span>{{ 'AI.SEGMENTATION_LIST.ALL' | translate}}</span>
                <svg *ngIf="objectCategoryName === 'AI.SEGMENTATION_LIST.ALL'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.BUILDING)" class="dropdown-option">
                <span>{{ 'AI.SEGMENTATION_LIST.BUILDINGS' | translate}}</span>
                <svg *ngIf="objectCategoryName === 'AI.SEGMENTATION_LIST.BUILDINGS'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.LV_POLES)" class="dropdown-option">
                <span>{{ 'AI.SEGMENTATION_LIST.LV_POLES' | translate}}</span>
                <svg *ngIf="objectCategoryName === 'AI.SEGMENTATION_LIST.LV_POLES'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.DISTRIBUTION_TRANSFORMERS_GROUND_MOUNTED)" class="dropdown-option">
                <span>{{ 'AI.DT_GROUND_MOUNTED' | translate}}</span>
                <svg *ngIf="objectCategoryName === 'AI.DT_GROUND_MOUNTED'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.DISTRIBUTION_TRANSFORMERS_POLE_MOUNTED)" class="dropdown-option">
                <span>{{ 'AI.DT_POLE_MOUNTED' | translate}}</span>
                <svg *ngIf="objectCategoryName === 'AI.DT_POLE_MOUNTED'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.MV_POLES)" class="dropdown-option">
                <span>{{ 'AI.SEGMENTATION_LIST.MV_POLES' | translate}}</span>
                <svg *ngIf="objectCategoryName === 'AI.SEGMENTATION_LIST.MV_POLES'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.INJECTION_SUBSTATIONS)" class="dropdown-option">
                <span>{{ 'AI.SEGMENTATION_LIST.INJECTION_SUBSTATIONS' | translate}}</span>
                <svg *ngIf="objectCategoryName === 'AI.SEGMENTATION_LIST.INJECTION_SUBSTATIONS'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.HV_POLES)" class="dropdown-option">
                <span>{{ 'AI.SEGMENTATION_LIST.HV_POLES' | translate }}</span>
                <svg *ngIf="objectCategoryName === 'AI.SEGMENTATION_LIST.HV_POLES'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div (click)="selectObjectCategoryOption(categoryTypeOptions.TRANSMISSION_STATIONS)" class="dropdown-option">
                <span>{{ 'AI.SEGMENTATION_LIST.TRANSMISSION_STATIONS' | translate }}</span>
                <svg *ngIf="objectCategoryName === 'AI.SEGMENTATION_LIST.TRANSMISSION_STATIONS'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
            <thead>
                <tr>
                    <th class="th-checkbox"><input type="checkbox" /></th>
                    <th>{{ 'AI.OBJECT_CATEGORY' | translate }}</th>
                    <th>ID</th>
                    <th>Type</th>
                    <th>{{ 'AI.SEGMENTATION_LIST.REAL_WORLD_LATITUDE' | translate }}</th>
                    <th>{{ 'AI.SEGMENTATION_LIST.CONNECTED_ASSET' | translate }}</th>
                    <th>{{ 'AI.SEGMENTATION_LIST.IMAGE_ID' | translate }}</th>
                    <th>{{ 'AI.SEGMENTATION_LIST.3D_IMAGE_ID' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let batchUpload of batchUploadObjects" (click)="onRowClick(batchUpload.id.toString())">
                    <td type="checkbox"><input type="checkbox"/></td>
                    <td>{{ mapObjectCategoryValue(batchUpload.objectCategory) | translate }}</td>
                    <td>{{ batchUpload.objectId }}</td>
                    <td>{{ batchUpload.type }}</td>
                    <td>{{ batchUpload.longitude + ',' + batchUpload.latitude }}</td>
                    <td>{{ batchUpload.connectedAsset }}</td>
                    <td class="image-link" (click)="onImageClick(batchUpload.imageId)">
                        {{ batchUpload.imageId.length > 30 ? (batchUpload.imageId | slice:0:30) + '...' : batchUpload.imageId }}
                    </td>
                    <td class="image-link" (click)="openModal(batchUpload.generatedObjectId)">
                        {{ batchUpload.generatedObjectId.length > 30 ? (batchUpload.generatedObjectId | slice:0:30) + '...' : batchUpload.generatedObjectId || '/' }}
                    </td>
                </tr>
            </tbody>
            </table>
            <div class="pagination">
                <lib-asset-list-pagination [pageFromList]="currentPage" (pageChanged)="onPageChange($event)" [totalItems]="count"></lib-asset-list-pagination>
            </div>
        </div>
    </div>
</div>

<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-body">
            <div class="image-modal" *ngIf="isImageModalOpen" (click)="closeImageModal()">
              <div class="image-modal-content" (click)="$event.stopPropagation()">
                <span class="close-button" (click)="closeImageModal()">&times;</span>
                <img [src]="selectedImageUrl" alt="Image" />
              </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="generatedObjectModalOpened">
    <lib-generated-object-representation (closeGeneratedObjectModal)="closeGeneratedModal()" [modelUrl]="selectedObjectUrl">
    </lib-generated-object-representation>
</ng-container>